import {
  Component,
  ViewEncapsulation,
  Inject,
  PLATFORM_ID,
  ElementRef,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { BuyerAuthService } from '../../services/buyer-auth/buyer-auth.service';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import {
  CustomValidator,
  emailValidator,
  matchingPasswords,
  passwordValidator,
} from 'src/app/_utlis/app-validators';
// import { Countries } from 'src/app/_utlis/countries';
import { TimeZoneService } from 'src/app/Shared/services/time-zone/time-zone.service';
import { DefulatRouting } from 'src/app/_utlis/enums/defualt-routing.enum';
import { environment } from 'src/environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { PreviousRouteService } from 'src/app/Shared/services/previous-route/previous-route.service';
import { Location, NgClass, CommonModule } from '@angular/common';

// Removed: getCurrentLngData, getPageData - migrated to ngx-translate
import { AnalyticsService } from 'src/app/Shared/_services/analytics/analytics.service';
import { getQueryString } from 'src/app/_utlis/convert-url';
import { LanguageSwitcherComponent } from '../../../../../../Shared/components/language-switcher/language-switcher.component';
import {
  MatFormField,
  MatError,
  MatSuffix,
} from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import {
  NgSelectComponent,
  NgOptionComponent,
  NgSelectModule,
} from '@ng-select/ng-select';
import { NumbersOnlyDirective } from '../../../../../../Shared/directives/numbersOnly/numbers-only.directive';
import { LogoComponent } from '../../../../../../Shared/components/logo/logo.component';
import { LanguageService } from 'src/app/Shared/services/language/language.service';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { isPlatformBrowser } from '@angular/common';
import { finalize, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { TranslatePipe } from '@ngx-translate/core';
import { IntlTelInputDirective } from 'src/app/Shared/directives/intl-input/intl-tel-input.directive';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { BreadCrumbsComponent } from 'src/app/Shared/components/bread-crumbs/bread-crumbs.component';
import { PasswordFormComponent } from '../../components/password-form/password-form.component';
import { BuyerService } from 'src/app/app-modules/buyer/_services/buyer/buyer.service';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import { GeographyService } from 'src/app/Shared/_services/geography.service';
import { TranslatedNamePipe } from 'src/app/Shared/_pipes/translated-name.pipe';
import { geographySearchFn } from 'src/app/Shared/_utils/geography-search.util';

// Custom validator function to ensure input contains only numbers
function numericValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  const valid = /^\d+$/.test(value);
  return valid ? null : { numeric: true };
}
interface Country {
  name: string;
  iso2: string;
  emoji?: string;
  states: State[];
}

interface State {
  name: string;
  id?: string;
}
@Component({
    selector: 'app-buyer-new-register',
        standalone: true,
templateUrl: './buyer-new-register.component.html',
    styleUrls: ['./buyer-register.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
    ReactiveFormsModule,
    MatInput,
    MatError,
    NgSelectComponent,
    NumbersOnlyDirective,
    RouterLink,
    NgClass,
    NgSelectModule,
    IntlTelInputDirective,
    BreadCrumbsComponent,
    CommonModule,
    PasswordFormComponent,
    TranslatePipe,
    TranslatedNamePipe
]
})
export class BuyerNewRegisterComponent {
  formData!: FormGroup;
  passwordForm!: FormGroup;
  profile_img: any;
  localFiles: any[] = [];

  activeTap = 'register';
  filesErrMsg = false;
  submit_clicked = false;
  // countriesCodes = Countries;

  // zones!: any[];
  // buyerDefualtPath = DefulatRouting.BUYER;
  buyerDefualtPath = environment.wordpressUrl;
  urlFront!: string;
  commonTranslations!: any;
  currentLang: any;
  isBrowser: boolean;
  appDir!: any;
  showErrors: boolean = false;

  selectedCountryIso = 'us';
  countries: Country[] = [];
  states: any[] = [];
  loading = false;

  // Shared search function for ng-select to search in both English and Arabic
  searchFn = geographySearchFn;

  phoneInputOptions = {
    initialCountry: 'US',
    separateDialCode: true,
    autoPlaceholder: 'aggressive',
    preferredCountries: ['us', 'gb', 'ca', 'au'],
    customContainer: 'w-100',
  };
  breadcrumbItems: Breadcrumb[] = [];
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: BuyerAuthService,
    private toastService: ToastService,
    private timeZoneService: TimeZoneService,
    private previousRouteService: PreviousRouteService,
    private _location: Location,
    private titleService: Title,
    private analyticsService: AnalyticsService,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private el: ElementRef,
    private buyerService: BuyerService,
    private languageService: LanguageService,
    private storage: StorageService,
    private geoGraphy: GeographyService
  ) {
    this.titleService.setTitle('Create Your Account | bidxsell');
    this.meta.addTag({
      name: 'description',
      content:
        'Join our online horse auction platform and start bidding on your dream horse. Register now at bidxsell.',
    });
    this.isBrowser = isPlatformBrowser(this.platformId);

    this.urlFront = environment.url_front;
    if (this.isBrowser) {
      this.currentLang = JSON.parse(
        localStorage.getItem(this.storage.getPrefixedKey('selectedLang')) ??
          '{}'
      );
    }

    this.initForm();
  }
  ngOnInit(): void {
    // Track sign up started
    // this.analyticsService.trackSignUpStarted(this.isBrowser ? document.referrer : undefined);
    // this.getTimeZones();
    this.loadCountries();
  }

  initForm() {
    this.formData = this.fb.group({
      user: new FormGroup({
        email: new FormControl(
          '',
          Validators.compose([Validators.required, emailValidator])
        ),
        name: new FormControl(
          '',
          Validators.compose([Validators.required, this.validateFullName])
        ),
        language_id: new FormControl(
          '', // Ensure the initial value is set
          Validators.compose([Validators.required])
        ),
        mobile_country_code: new FormControl(
          '+1',
          Validators.compose([Validators.required])
        ),
        mobile: new FormControl(
          '',
          Validators.compose([Validators.required, numericValidator])
        ),
      }),
      buyer: new FormGroup({
        address_1: new FormControl(
          '',
          Validators.compose([Validators.required])
        ),
        address_2: new FormControl(''),
        country_id: new FormControl(
          null,
          Validators.compose([Validators.required])
        ),
        state_city_id: new FormControl(
          null,
          Validators.compose([Validators.required])
        ),
        postcode: new FormControl(
          '',
          Validators.compose([Validators.required])
        ),
      }),
    });
    this.passwordForm = this.fb.group(
      {
        password: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            CustomValidator.patternValidator(/\d/, { hasNumber: true }),
            CustomValidator.patternValidator(/[a-zA-Z]/, { hasAlphabet: true }),
          ])
        ),
        password_confirmation: new FormControl(
          '',
          Validators.compose([Validators.required])
        ),
        accept_terms: new FormControl(true),
      },
      { validators: matchingPasswords('password', 'password_confirmation') }
    );

    if (this.currentLang?.id) {
      this.formData.patchValue({
        user: {
          language_id: this.currentLang?.id,
        },
      });
    }
  }
  onPasswordFormChange(form: FormGroup): void {
    this.passwordForm = form;
  }

  canSubmit(): boolean {
    return (
      this.formData.valid &&
      this.passwordForm?.valid &&
      this.passwordForm?.value.accept_terms
    );
  }
  // getTimeZones() {
  //   this.timeZoneService.getTimeZones().subscribe((res) => {
  //     this.zones = res.data;
  //   });
  // }

  onImageChanged(e: any) {
    this.profile_img = e.files[0];
  }
  onMediaChanged(e: any) {
    this.localFiles = [...e.files];
  }
  next() {
    this.formData.markAllAsTouched();
    this.filesErrMsg = true;
    if (this.formData.valid) {
      this.activeTap = 'create-password';
    } else {
      this.showErrors = true;
      this.scrollToFirstError();
    }
  }
  onSubmit() {
    this.toastService.clear();

    if (this.canSubmit()) {
      const body = {
        user: {
          ...this.formData.value.user,
          profile_image: this.profile_img,
          ...this.passwordForm.value,
        },
        buyer: {
          ...this.formData.value.buyer,
        },
      };

      // if (
      //   this.formData.valid &&
      //   this.passwordForm.valid &&
      //   this.passwordForm.value.accept_terms
      // ) {
      this.submit_clicked = true;

      this.authService.register(body).subscribe({
        next: (response) => {
          this.router.navigate(['/buyer/auth/verify-email'], {
            queryParams: { email: response.data.email },
          });
          // Track successful registration
          // this.analyticsService.trackSignUp(true, this.currentLang?.slug);
        },
        error: (error) => {
          this.submit_clicked = false;
          this.showErrors = true;

          this.activeTap = 'register';

          // Track failed registration
          const errorReason = error.error.error?.global?.[0] ||
            Object.values(error.error.error?.fields || {})[0] ||
            'unknown';
          // this.analyticsService.trackSignUp(false, this.currentLang?.slug, String(errorReason));

          if (error.error.error?.fields) {
            this.handleErrors(error.error.error.fields);
            this.showErrors = true;
            this.scrollToFirstError();
          }

          // Handle global errors
          if (error.error.error?.global) {
            error.error.error.global.forEach((err: string) => {
              this.toastService.showError(err);
            });
          }
        },
      });
    } else {
      this.showErrors = true;
      this.markFormGroupTouched(this.formData);
      this.markFormGroupTouched(this.passwordForm);
      this.scrollToFirstError();
    }
  }
  handleErrors(error: any) {
    Object.entries(error).forEach(([field, message]) => {
      // Get the form control path from the error field
      const controlPath = field.split('.');

      const control =
        controlPath.length > 1
          ? this.formData.get(controlPath[0])?.get(controlPath[1])
          : this.formData.get(controlPath[0]);

      if (control) {
        control.setErrors({
          serverError: message,
        });
      }
    });
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control) => {
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control.markAsTouched();
        control.updateValueAndValidity();
      }
    });
  }

  scrollToFirstError(): void {
    setTimeout(() => {
      const firstErrorElement: HTMLElement | null =
        this.el.nativeElement.querySelector(
          '.is-invalid.input-field , .is-invalid input, .is-invalid textarea, .is-invalid select, .is-invalid mat-select, .is-invalid .map .my-search-box , .is-invalid mat-form-field,.is-invalid ng-select'
        );

      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        firstErrorElement.focus();
      }
    }, 100);
  }
  handleClick(e: any) {
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
  }
  validateFullName(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    const fullName = control.value;
    if (fullName) {
      const words = fullName.trim().split(/\s+/);

      if (words.length < 2) {
        return { invalidFullName: true };
      }

      for (let word of words) {
        if (word.length < 2) {
          return { invalidFullName: true };
        }
      }
    }

    return null;
  }
  back() {
    this.router.navigate(['/']);
  }
  loadCountries(): void {
    this.loading = true;

    this.geoGraphy
      .countries()
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(
        (response: any) => {
          // Extract data from API response
          const data = response?.data || response;

          if (!data) {
            console.error('No data received from countries API');
            this.countries = [];
            return;
          }

          // Convert data to array if needed
          if (Array.isArray(data)) {
            this.countries = data;
          } else if (typeof data === 'object') {
            this.countries = Object.values(data);
          } else {
            console.error('Unexpected data format:', typeof data);
            this.countries = [];
            return;
          }

          // Sort countries alphabetically by name
          this.countries.sort((a, b) => {
            if (!a?.name) return -1;
            if (!b?.name) return 1;
            return a.name.localeCompare(b.name);
          });
        },
        (error) => {
          console.error('Failed to load countries:', error);
          this.countries = [];
        }
      );
  }

  citiesLoading = false;

  onCountryChange(country: any): void {
    const buyerGroup = this.formData.get('buyer') as FormGroup;
    if (buyerGroup) {
      buyerGroup.get('state_city_id')?.setValue(null);
      buyerGroup.get('state_city_id')?.disable();
    }

    this.states = [];

    if (country && country.id) {
      // Load cities from API
      this.citiesLoading = true;
      this.geoGraphy
        .statesCities(country.id)
        .pipe(finalize(() => (this.citiesLoading = false)))
        .subscribe(
          (response: any) => {
            const data = response?.data || response;
            if (Array.isArray(data)) {
              this.states = [...data].sort((a, b) => {
                return String(a.name || '').localeCompare(String(b.name || ''));
              });
            }
            if (this.states.length > 0 && buyerGroup) {
              buyerGroup.get('state_city_id')?.enable();
            }
          },
          (error) => {
            console.error('Failed to load cities:', error);
            this.states = [];
          }
        );
    }
  }
  getCountryCodeByName(countryName: string, countries: any[]): string | null {
    // Normalize the input name for case-insensitive comparison
    const normalizedName = countryName.trim().toLowerCase();

    // Find the matching country
    const country = countries.find((c) => {
      // console.log(c.name.toLowerCase(), normalizedName);

      return c.name.toLowerCase().includes(normalizedName);
    });

    // Return the code if found, otherwise null
    return country ? country.code : null;
  }
  isPhoneValid = false;

  onPhoneCountryChange(data: any): void {
    const userGroup = this.formData.get('user') as FormGroup;

    if (data && data.dialCode) {
      userGroup.get('mobile_country_code')?.setValue(data.dialCode);
    }

    // Reset mobile number when country changes
    if (userGroup.get('mobile')?.value) {
      userGroup.get('mobile')?.setValue('');
    }
  }

  onPhoneValidityChange(isValid: boolean): void {
    this.isPhoneValid = isValid;
  }

  onPhoneNumberChange(event: any): void {
    if (event && event.isValidNumber) {
      // Get the selected country data to access the dial code
      const countryData = event.countryData;
      const userGroup = this.formData.get('user') as FormGroup;

      if (userGroup) {
        // Update country code (without the + sign)
        userGroup.get('mobile_country_code')?.setValue(event.dialCode);
        const nationalNumber = event.nationalNumber;
        userGroup.get('mobile')?.setValue(nationalNumber.trim());
      }
      if (this.isPhoneValid) {
        this.phoneErrorMessage = '';
      }
    }
  }
  phoneErrorMessage: string = '';
  onPhoneValidationError(error: string) {
    this.phoneErrorMessage = error;

    const mobileControl = this.formData.get('user')?.get('mobile');
    if (error && mobileControl) {
      mobileControl.setErrors({ invalidFormat: true });
    } else if (
      mobileControl &&
      mobileControl.errors &&
      mobileControl.errors['invalidFormat']
    ) {
      // Clear only the invalidFormat error if it exists
      const errors = { ...mobileControl.errors };
      delete errors['invalidFormat'];

      // If no errors left, set to null
      mobileControl.setErrors(Object.keys(errors).length ? errors : null);
    }
  }

  goToHomepage(): void {
    this.router.navigate(['/']);
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }

  // Helper method to check if a field is invalid and touched
  isInvalid(controlName: string): boolean {
    const control = this.formData.get(controlName);
    return !!control && control.invalid && (control.dirty || control.touched);
  }
}
